<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { getFAQData } from '../../utils/recommendationLogic.js';

  const faqs = getFAQData();

  // Formstack HOSTED form URL. Iframed directly via src — the hosted page
  // sends no X-Frame-Options and serves ACAO:*, so it embeds cross-origin
  // on both desktop and mobile. (The prior approach document.write'd the
  // loader script into a srcless iframe, which iOS Safari silently refuses
  // to execute — the form rendered blank on mobile.)
  const FORMSTACK_URL = 'https://formstack.io/1068E';

  let openItems = [];

  function toggleFAQ(index) {
    if (openItems.includes(index)) {
      openItems = openItems.filter(i => i !== index);
    } else {
      openItems = [...openItems, index];
    }
  }

  function handleBack() {
    surveyStore.goToScreen('result', 5);
  }
</script>

<div class="card">
  <h2 class="card-title" style="font-size:1.5rem">Common <em>questions.</em></h2>
  <div class="card-body">
    <p>Everything you need to know about the Season Ticket Membership.</p>
  </div>

  {#each faqs as faq, index}
    <div class="faq-item" class:open={openItems.includes(index)}>
      <div class="faq-q" on:click={() => toggleFAQ(index)} on:keypress={(e) => e.key === 'Enter' && toggleFAQ(index)} role="button" tabindex="0">
        {faq.question}
      </div>
      <div class="faq-a">
        {faq.answer}
      </div>
    </div>
  {/each}

  <div class="divider"></div>

  <!-- Formstack Contact Form -->
  <div class="rep-contact-box">
    <div class="result-section-label" style="margin-top:0">Still have questions?</div>
    <p>A member of our team can walk you through everything. Fill out the form below and we'll be in touch.</p>

    <!-- Hosted Formstack form, embedded directly (works on desktop + mobile) -->
    <div id="iFrameWrapper" style="margin-top: 1rem;">
      <iframe
        src={FORMSTACK_URL}
        frameborder="0"
        scrolling="auto"
        name="ffEmbedFrame"
        id="ffEmbedFrame"
        title="Contact Form"
        style="width: 100%; min-height: 700px; border: 0;"
      ></iframe>
    </div>
  </div>

  <button class="cta-secondary" style="margin-top:1rem" on:click={handleBack}>
    ← Back to my membership match
  </button>
</div>
